<template>
  <div class="EnterpriseBasicDatadata">
    <div class="con">
      <div class="tree-left">
        <elUnitTree
          @checkFun="checkFun"
          :dataList="virtualDeviceList"
        ></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <div class="input-small mr-20">
            <span>开始时间：</span>
            <el-date-picker
              v-model="bgTime"
              type="date"
              placeholder="选择时间"
              align="right"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="input-small ">
            <span>结束时间：</span>
            <el-date-picker
              v-model="endTime"
              type="date"
              placeholder="选择时间"
              align="right"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <el-button type="primary" plain @click="getList" class="search-btn"
            >查询</el-button
          >
          <el-button @click="newexportList" type="primary" class="search-btn"
            >导出</el-button
          >
        </div>
        <div class="mycharts" style="height:50%">
          <div class="charts-left">
            <div id="chart_example" style="height:100%;"></div>
          </div>
          <div class="charts-right">
            <div id="chart_example2" style="height:100%;"></div>
          </div>
        </div>
        <div class="mytable" id="printCons">
          <el-table
            :data="tableData11"
            style="width: 100%"
            border
            :max-height="tabheights"
          >
            <el-table-column label="序号" width="60" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据" />
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="variableName" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="variableType" label="类型" width="180">
              <template slot-scope="scope">{{
                scope.row.variableType | company
              }}</template>
            </el-table-column>
            <el-table-column prop="energyTotal" label="电量（KWh）">
            </el-table-column>
            <el-table-column
              prop="energyChargeTotal"
              label="电费"
            ></el-table-column>
          </el-table>
        </div>
        <!-- <div class="mytable"  v-show="false">
          <el-table :data="newtableData" style="width: 100%" border :max-height="tabheights">
            <el-table-column label="序号" width="60" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="variableName" label="设备名称" min-width="180"> </el-table-column>
            <el-table-column prop="351liang" label="尖电量" min-width="180"></el-table-column>
            <el-table-column prop="352liang" label="峰电量" min-width="180"> </el-table-column>
            <el-table-column prop="353liang" label="平电量" min-width="180"></el-table-column>
            <el-table-column prop="354liang" label="谷电量" min-width="180"></el-table-column>
            <el-table-column prop="1000liang" label="总电量" min-width="180"></el-table-column>
            <el-table-column prop="351fei" label="尖电费" min-width="180"></el-table-column>
            <el-table-column prop="352fei" label="峰电费" min-width="180"></el-table-column>
            <el-table-column prop="353fei" label="平电费" min-width="180"></el-table-column>
            <el-table-column prop="354fei" label="谷电费" min-width="180"></el-table-column>
            <el-table-column prop="1000fei" label="总电费" min-width="180"></el-table-column>
          </el-table>
        </div> -->
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <downloadTable ref="downloadTable"></downloadTable>
      </div>
    </div>
  </div>
</template>
<script>
// import { ElectricAnalyse } from "@/utils/request";
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
import { getStatisticsPG } from "../../api/rateTemplate";
import * as echarts from "echarts";
// import { parseTime } from "@/utils";
import $ from "jquery";
var myChart, myChart2;
export default {
  components: {
    elUnitTree,
    downloadTable,
  },
  data() {
    return {
      loading: false,
      tableData11: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 86400000;
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      treeList: [],
      error: true,
      today: "",
      value1: [new Date(), new Date()],
      bgTime: new Date().getTime() - 86400000,
      endTime: new Date().getTime() - 86400000,
      num: 19,
      tempId: [],
      flag: true, //显示树形
      tabheights: Math.round(
        document.getElementById("app").clientHeight * 0.36
      ),
      tableData: [
        {
          Electricity_1000: 1152,
          Electricity_351: 288,
          Electricity_352: 288,
          Electricity_353: 288,
          Electricity_354: 288,
          Tariff_1000: 1440,
          Tariff_351: 316.8,
          Tariff_352: 345.6,
          Tariff_353: 374.39,
          Tariff_354: 403.19,
        },
      ],
      newtableData: [],
      data: JSON.parse(localStorage.getItem("getReadDeviceTree")),
      defaultProps: {
        label: "Content",
        children: "ChildDatas",
      },
      ids: "",
      columns: [
        {
          name: "总电量",
          key: "Electricity_1000",
        },
        {
          name: "尖电量",
          key: "Electricity_351",
        },
        {
          name: "峰电量",
          key: "Electricity_352",
        },
        {
          name: "平电量",
          key: "Electricity_353",
        },
        {
          name: "谷电量",
          key: "Electricity_354",
        },
        {
          name: "尖电费",
          key: "Tariff_351",
        },
        {
          name: "峰电费",
          key: "Tariff_352",
        },
        {
          name: "平电费",
          key: "Tariff_353",
        },
        {
          name: "谷电费",
          key: "Tariff_354",
        },
        {
          name: "总电费",
          key: "Tariff_1000",
        },
      ],

      columns1: [
        {
          name: "总电量",
          key: "Electricity_1000",
        },
        {
          name: "尖电量",
          key: "Electricity_351",
        },
        {
          name: "峰电量",
          key: "Electricity_352",
        },
        {
          name: "平电量",
          key: "Electricity_353",
        },
        {
          name: "谷电量",
          key: "Electricity_354",
        },
      ],
      columns2: [
        {
          name: "总电费",
          key: "Tariff_1000",
        },
        {
          name: "尖电费",
          key: "Tariff_351",
        },
        {
          name: "峰电费",
          key: "Tariff_352",
        },
        {
          name: "平电费",
          key: "Tariff_353",
        },
        {
          name: "谷电费",
          key: "Tariff_354",
        },
      ],
      option: {
        // title: {
        //   text: '占比分析',
        //   textStyle: {
        //     color: '#333',
        //     fontStyle: 'normal',
        //     fontWeight: '400',
        //     fontFamily: 'sans-serif',
        //     fontSize: 15
        //   },
        // },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}(kWh)  ({d}%)",
        },
        legend: {
          type: "scroll",
          top: 0,
        },
        series: [
          {
            name: "电量",
            type: "pie",
            radius: ["35%", "50%"],
            label: {
              position: "inner",
              show: false,
            },
            data: [
              {
                name: "总电量",
                value: "10",
              },
              {
                name: "尖电量",
                value: "10",
              },
              {
                name: "峰电量",
                value: "10",
              },
              {
                name: "平电量",
                value: "10",
              },
              {
                name: "谷电量",
                value: "10",
              },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c} ({d}%)",
                },
                labelLine: { show: true },
              },
            },
          },
          {
            name: "电费",
            type: "pie",
            selectedMode: "single",
            radius: [0, "25%"],
            label: {
              normal: {
                position: "inner",
                show: false,
              },
            },
            data: [
              {
                name: "总电费",
                value: "10",
              },
              {
                name: "尖电费",
                value: "10",
              },
              {
                name: "峰电费",
                value: "10",
              },
              {
                name: "平电费",
                value: "10",
              },
              {
                name: "谷电费",
                value: "10",
              },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c} ({d}%)",
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      },
      option2: {
        // title: {
        //   text: '累计趋势',
        //   textStyle: {
        //     color: '#333',
        //     fontStyle: 'normal',
        //     fontWeight: '400',
        //     fontFamily: 'sans-serif',
        //     fontSize: 15
        //   }
        // },
        // color: ['#c23531', '#2f4554', '#61a0a8'],
        // color: ['#c23531', '#2f4554', '#61a0a8','red'],
        grid: {
          top: 30,
          left: 50,
          right: 5,
          bottom: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}(kWh) ",
        },
        dataZoom: [
          {
            show: false,
          },
          {
            type: "inside",
          },
        ],
        xAxis: { data: ["示例1", "示例2", "示例3"] },
        series: [
          {
            type: "bar",
            data: [
              { name: "示例1", value: "0.00" },
              { name: "示例2", value: "0.00" },
              { name: "示例3", value: "0.00" },
            ],
            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = [
                    // 每根颜色顺序
                    "#5c7bd9",
                    "#91cc75",
                    "#fedb5f",
                    "#fb6d6d",
                    "#7ed3f4",
                    "#40b27d",
                    "#ff915a",
                    "#a969c6",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function(value, index) {
              return value.toFixed(1);
            },
          },
        },
      },
      mynum: 1,
      a: [],
      b: [{ label: "C1FB-G01-C3FA出线柜" }],
    };
  },

  created() {
    // this.treeList = JSON.parse(localStorage.getItem('treeList'))
    //       console.log("树形",this.treeList);
  },
  computed: {
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
  },
  mounted() {
    this.init();
    this.getList();
  },
  methods: {
    //树形结构选择
    checkFun(val) {
      this.b = val;
    },

    // 下载excel
    newexportList() {
      const tHeader = [];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.tableData,
        "尖峰平谷",
        "#printCons"
      );
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    //获取数据
    getList() {
      var d = {
        grid: { top: 30, left: 50, right: 5, bottom: 10, containLabel: true },
        tooltip: { trigger: "axis", formatter: "{b}: {c}(kWh) " },
        dataZoom: [{ show: false }, { type: "inside" }],
        xAxis: {
          data: [
            "尖电量",
            "峰电量",
            "平电量",
            "谷电量",
            "尖电费",
            "峰电费",
            "平电费",
            "谷电费",
          ],
        },
        series: [
          {
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            itemStyle: { normal: {} },
          },
        ],
        yAxis: { type: "value", axisLabel: {} },
      };
      myChart2.setOption(d);
      this.tableData11 = [
        {
          variableName: "设备机电总进线数显表",
          variableType: "351",
          energyTotal: Math.floor(Math.random() * 10),
          energyChargeTotal: Math.floor(Math.random() * 10),
        },
        {
          variableName: "设备机电总进线数显表",
          variableType: "352",
          energyTotal: Math.floor(Math.random() * 10),
          energyChargeTotal: Math.floor(Math.random() * 10),
        },
        {
          variableName: "设备机电总进线数显表",
          variableType: "353",
          energyTotal: Math.floor(Math.random() * 10),
          energyChargeTotal: Math.floor(Math.random() * 10),
        },
        {
          variableName: "设备机电总进线数显表",
          variableType: "354",
          energyTotal: Math.floor(Math.random() * 10),
          energyChargeTotal: Math.floor(Math.random() * 10),
        },
        {
          variableName: "设备机电总进线数显表",
          variableType: "1000",
          energyTotal: Math.floor(Math.random() * 10),
          energyChargeTotal: Math.floor(Math.random() * 10),
        },
      ];

      return;
    },

    // 树形筛选
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 初始化图表
    init() {
      myChart = echarts.init(document.getElementById("chart_example"));
      myChart2 = echarts.init(document.getElementById("chart_example2"));
      // legend: {
      //     data: d,
      //     top: this.heights - 150
      //   },

      myChart.setOption(this.option);
      myChart.resize();

      myChart2.setOption(this.option2);
      myChart2.resize();
      $(window).resize(function() {
        myChart.resize();
        myChart2.resize();
      });
    },
  },
  //过滤器
  filters: {
    //费率类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val) {
      if (val == "ELECTRIC") {
        return "电";
      } else if (val == "WATER") {
        return "水";
      } else {
        return "气";
      }
    },
    //单位类型
    company(val) {
      if (val == "351") {
        return "尖";
      } else if (val == "352") {
        return "峰";
      } else if (val == "353") {
        return "平";
      } else if (val == "354") {
        return "谷";
      } else if (val == "1000") {
        return "总";
      }
    },
    //阶梯名称
    sectionNameFun(val) {
      if (val == "第1阶梯") {
        return "第一阶梯";
      } else if (val == "第2阶梯") {
        return "第二阶梯";
      } else if (val == "第3阶梯") {
        return "第三阶梯";
      } else {
        return val;
      }
    },
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let strDate = Y + M + D + h + m + s;
      return strDate;
    },
  },
};
</script>
<!-- <style>
  .name-wrapper {
    background: #1890ff;
    color: #fff;
  }
</style> -->
<style lang="scss" scoped>
.EnterpriseBasicDatadata .con .right-table {
  overflow-y: scroll;
}

.search-input-btn {
  margin-bottom: 0px;
}

.EnterpriseBasicDatadata {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button + .el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;
        margin: 10px 0px;

        .charts-left {
          width: 50%;
          border-right: 1px solid #e6e6e6;
        }

        .charts-right {
          width: 50%;
        }
      }
    }
  }
}
</style>
